import { SERVICE_GROUP_ID } from '@/constants';

// GLOBIS 学び放題: 1, eMBA2.0: 2, GLOBIS 学び放題プラス（旧）: 3, GU: 7
export const isDisplaySubscriptionList = (serviceId: number) =>
  [1, 2, 3, 7].includes(serviceId);

export const isTransferredServiceGroupId = (serviceGroupId: number) =>
  [SERVICE_GROUP_ID.hodai, SERVICE_GROUP_ID.gu].includes(serviceGroupId);
